import React from "react";
import "./Logo.css";

export default function Logo() {
  return (
    <header className="navbar">
      <div className="navbar__inner">
        <a href="/" className="navbar__logo">
          <img src="/logo.png" alt="logo" />
        </a>
      </div>
    </header>
  );
}